export default Object.freeze({
  PlanIncludedMonthlyCredit: 1,
  PromotionalCredit: 2,
  ManualBonus: 3,
  SupportCompensation: 4,
  PaidCredit: 5,
  Adjustment: 6,
});
